import { AppCardSkeleton, AppCardSkeletonMetaFooter } from '@app/components/base/app-card';

/**
 * One skeleton placeholder card matching YoutubeBroadcastCard layout.
 */
export function YoutubeBroadcastCardSkeleton() {
  return <AppCardSkeleton footer={<AppCardSkeletonMetaFooter />} />;
}
